import { startOfUtcDay } from './dates';

export function getToday() {
  return startOfUtcDay(new Date());
}
